import { FirebaseError } from "@firebase/util"
import { useTieupToast } from "./useTieupToast"

/** 日本語のエラーメッセージを返す */
const createErrorMessage = (code: string) => {
  switch (code) {
    case "auth/cancelled-popup-request":
    case "auth/popup-closed-by-user": {
      return null
    }
    case "auth/email-already-in-use": {
      return "このメールアドレスはすでに使用されています"
    }
    case "auth/invalid-email": {
      return "メールアドレスの形式が正しくありません"
    }
    case "auth/user-disabled": {
      return "サービスの利用が停止されています"
    }
    case "auth/user-not-found": {
      return "ユーザーが存在しません"
    }
    case "auth/user-mismatch": {
      return "認証されているユーザーと異なるアカウントが選択されました"
    }
    case "auth/weak-password": {
      return "パスワードは6文字以上にしてください"
    }
    case "auth/wrong-password": {
      return "パスワードが違います"
    }
    case "auth/popup-blocked": {
      return "認証ポップアップがブロックされました。ポップアップブロックをご利用の場合は設定を解除してください"
    }
    case "auth/requires-recent-login": {
      return "認証の有効期限が切れています"
    }
    default: {
      return "エラーが発生しました。しばらく時間をおいてお試しください"
    }
  }
}

/** Firebase Authのエラーハンドリング */
const useFirebaseAuthError = () => {
  const { addToastError } = useTieupToast()

  /** エラー表示 */
  const showFirebaseError = (error: FirebaseError) => {
    // エラーメッセージ
    const errorMessage = createErrorMessage(error.code)
    // 通知
    if (errorMessage) {
      addToastError(errorMessage)
    }
  }

  return {
    showFirebaseError,
  }
}

export { useFirebaseAuthError }
